// This file was automatically generated and should not be edited.
/* eslint-disable */

type Locale = 'en' | 'es';

type Phrase = (l: Locale) => string;

export const i18n_homepage_description: Phrase = locale => {
  const phrases: { [key: string]: undefined | string } = {
    en: `Join The Yoga International community for a higher level of health and happiness through yoga. Read articles and download or live stream videos today.`,
    es: `Únete a la comunidad de Yoga International para traer salud y felicidad a tu vida a través de la práctica del yoga. Lee nuestros artículos y mira nuestros videos ahora mismo.`,
  };
  return phrases[locale] || phrases.en || 'homepage_description';
};
